import React, { SVGProps } from 'react';

const Package: React.FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 32 32'
        width={16}
        height={16}
        {...props}
    >
        <path
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M28 22.165V9.835a1 1 0 0 0-.51-.872l-11-6.187a1 1 0 0 0-.98 0l-11 6.187a1 1 0 0 0-.51.872v12.33a1 1 0 0 0 .51.872l11 6.187a1 1 0 0 0 .98 0l11-6.187a1 1 0 0 0 .51-.872'
        />
        <path
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M22.128 19.064v-6.5L10 5.875'
        />
        <path
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M27.862 9.328 16.12 16 4.139 9.327M16.119 16 16 29.353'
        />
    </svg>
);

export default Package;
